import { render, staticRenderFns } from "./chateau-haut-bages-liberal.vue?vue&type=template&id=3fcf9fcb&scoped=true"
import script from "./chateau-haut-bages-liberal.vue?vue&type=script&lang=js"
export * from "./chateau-haut-bages-liberal.vue?vue&type=script&lang=js"
import style0 from "./chateau-haut-bages-liberal.vue?vue&type=style&index=0&id=3fcf9fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf9fcb",
  null
  
)

export default component.exports